import React from 'react'

import { IIcons } from './types'

export default (props: IIcons) => {
  const { style } = props
  const defaultStyle = { width: 163, height: 148 }

  return (
    <svg style={{ ...defaultStyle, ...style }} viewBox="0 0 163 148" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dddd)">
        <rect x="47.8066" y="8" width="83.1933" height="83.1933" rx="4" fill="white" />
      </g>
      <g filter="url(#filter1_dddd)">
        <rect x="32" y="24.6387" width="74.042" height="36.605" rx="4" fill="url(#paint0_radial)" />
        <rect x="32.5" y="25.1387" width="73.042" height="35.605" rx="3.5" stroke="white" />
      </g>
      <g filter="url(#filter2_dddd)">
        <rect x="41.9834" y="39.6133" width="54.0756" height="6.65546" rx="3.32773" fill="white" />
      </g>
      <g filter="url(#filter3_dddd)">
        <path
          d="M114.862 58.5709C112.891 56.2884 111.032 52.2059 106.31 45.8966C104.915 44.0224 100.639 40.2368 100.639 40.2368L99.4495 39.0492C98.4084 38.01 96.8653 37.7317 95.7312 38.6595C94.4297 39.7172 94.374 41.6471 95.5267 42.7976L93.779 41.0533C92.7379 40.0141 91.0646 39.8471 89.9491 40.775C88.6477 41.8327 88.5919 43.7626 89.7446 44.9131L88.2945 43.4657C87.2533 42.4265 85.5801 42.2595 84.4646 43.1873C83.1631 44.2451 83.1074 46.175 84.2601 47.3255L77.4369 40.5152C76.2842 39.3646 74.425 39.1791 73.1794 40.2183C71.7478 41.4059 71.6735 43.5214 72.9563 44.8018L88.9266 60.742C88.8522 60.7235 88.7778 60.7049 88.7035 60.6863C85.1153 59.6472 83.2375 58.9049 83.2375 58.9049L81.8617 58.4967C80.4487 58.0327 79.6679 58.107 78.6825 58.9791C78.0876 59.5173 77.7901 60.1482 77.8273 61.076C77.8645 62.5791 78.6639 63.0802 79.3704 63.507L79.6121 63.6369C79.6121 63.6369 85.2454 66.4204 92.3289 67.8121C97.0884 68.74 99.8585 70.8554 101.569 71.8761"
          fill="white"
        />
        <path
          d="M101.514 73.1973C101.291 73.1973 101.049 73.1417 100.844 73.0118C100.584 72.8633 100.305 72.6777 100.008 72.4922C98.3531 71.4344 95.8618 69.8571 92.0133 69.0963C84.8369 67.7045 79.2036 64.9396 78.9619 64.8097C78.9433 64.8097 78.9247 64.7911 78.9061 64.7911L78.6644 64.6612C78.6458 64.6427 78.6273 64.6427 78.6087 64.6241C77.8836 64.1788 76.5264 63.3437 76.452 61.1354C76.4148 59.855 76.8238 58.8344 77.7348 58.0365C79.2222 56.7004 80.5794 56.7746 82.1597 57.2756L83.5355 57.6839C83.5727 57.7024 83.5912 57.7024 83.6284 57.721C83.6284 57.721 83.8143 57.7952 84.1862 57.9251L71.9714 45.7333C71.0976 44.8612 70.6328 43.655 70.6886 42.4117C70.7444 41.1869 71.3393 40.0179 72.2875 39.2199C74.0165 37.7911 76.6565 37.9581 78.2926 39.6096L82.42 43.7292C82.6803 43.1354 83.0707 42.6158 83.5727 42.2076C84.7625 41.2241 86.3986 41.057 87.793 41.6509C88.0347 40.9271 88.4809 40.2962 89.0758 39.7952C90.3586 38.7375 92.1806 38.6261 93.6494 39.4055C93.9097 38.7375 94.3187 38.1436 94.8764 37.6983C96.4567 36.3993 98.7621 36.5849 100.342 38.1622L101.495 39.3127C101.904 39.6838 105.901 43.2467 107.314 45.1395C109.936 48.6468 111.665 51.4303 113.059 53.6571C114.137 55.4014 114.993 56.7746 115.829 57.7396C116.294 58.2777 116.238 59.0942 115.699 59.5767C115.16 60.0406 114.342 59.9849 113.859 59.4468C112.892 58.3334 111.999 56.886 110.865 55.0488C109.508 52.8591 107.798 50.1127 105.251 46.7169C103.949 44.9725 99.7847 41.2797 99.7475 41.2426C99.7289 41.2241 99.7103 41.2055 99.6917 41.1869L98.5018 39.9993C97.9998 39.4983 97.1632 39.1828 96.5311 39.7024C96.1965 39.9808 96.0105 40.3704 95.9734 40.7973C95.9548 41.2241 96.1035 41.6323 96.4195 41.9292C96.9215 42.4302 96.9215 43.2653 96.4195 43.7663C95.9176 44.2674 95.0809 44.2674 94.579 43.7663L92.8313 42.022C92.2364 41.4282 91.3254 41.354 90.7305 41.8364C90.3958 42.1148 90.2099 42.5045 90.1727 42.9313C90.1541 43.3581 90.3029 43.7663 90.6189 44.0632C90.8792 44.323 90.9908 44.6571 90.9908 44.9725C90.9908 45.3065 90.8606 45.6406 90.6189 45.8818C90.117 46.3828 89.2803 46.3828 88.7783 45.8818L87.3282 44.4344C86.7333 43.8406 85.8223 43.7663 85.2273 44.2488C84.8927 44.5272 84.7068 44.9168 84.6696 45.3437C84.651 45.7705 84.7997 46.1787 85.1158 46.4756C85.3761 46.7354 85.4876 47.0694 85.4876 47.3849C85.4876 47.7189 85.3575 48.0529 85.1158 48.2942C84.6138 48.7952 83.7772 48.7952 83.2752 48.2942L76.452 41.4839C75.7455 40.7787 74.6486 40.6859 73.9421 41.2612C73.5331 41.5952 73.31 42.0591 73.2728 42.5787C73.2542 43.0983 73.4402 43.5808 73.7934 43.9333L89.7637 59.8736C90.1727 60.2818 90.2657 60.9128 89.9868 61.4138C89.7079 61.9148 89.1316 62.1746 88.5552 62.0447C88.4623 62.0262 88.3693 62.0076 88.2578 61.9705C84.9299 61.0055 83.0521 60.3004 82.7174 60.1705L81.3788 59.7622H81.3602C80.189 59.3911 79.9659 59.521 79.4639 59.9849C79.1664 60.2447 79.0177 60.5045 79.0363 61.0798C79.0549 61.8777 79.3337 62.0633 79.9287 62.4344L80.1146 62.5272C80.505 62.7128 85.878 65.2922 92.4781 66.5726C96.81 67.4076 99.543 69.1705 101.365 70.321C101.644 70.5066 101.904 70.6736 102.146 70.8035C102.759 71.1746 102.964 71.9726 102.592 72.585C102.387 72.9746 101.96 73.1973 101.514 73.1973Z"
          fill="#2D2D2D"
        />
        <path
          d="M93.6117 50.1098C93.277 50.1098 92.9424 49.98 92.7007 49.7387L88.7964 45.8418C88.2944 45.3408 88.2944 44.5057 88.7964 44.0047C89.2984 43.5036 90.135 43.5036 90.637 44.0047L94.5413 47.9016C95.0432 48.4026 95.0432 49.2377 94.5413 49.7387C94.281 49.98 93.9463 50.1098 93.6117 50.1098Z"
          fill="#2D2D2D"
        />
        <path
          d="M89.6518 54.0651C89.3172 54.0651 88.9825 53.9352 88.7408 53.694L83.312 48.2754C82.8101 47.7744 82.8101 46.9393 83.312 46.4383C83.814 45.9372 84.6506 45.9372 85.1526 46.4383L90.5814 51.8568C91.0834 52.3579 91.0834 53.1929 90.5814 53.694C90.3211 53.9352 89.9865 54.0651 89.6518 54.0651Z"
          fill="#2D2D2D"
        />
        <path
          d="M97.5719 46.1614C97.2372 46.1614 96.9026 46.0315 96.6609 45.7903L94.5972 43.7305C94.0952 43.2294 94.0952 42.3944 94.5972 41.8934C95.0992 41.3923 95.9358 41.3923 96.4378 41.8934L98.5014 43.9532C99.0034 44.4542 99.0034 45.2892 98.5014 45.7903C98.2412 46.0315 97.9065 46.1614 97.5719 46.1614Z"
          fill="#2D2D2D"
        />
        <path
          d="M119.25 63.2859L106.106 76.4055C106.013 76.4983 105.845 76.4983 105.734 76.4055L101.551 72.2303C101.458 72.1375 101.458 71.9705 101.551 71.8591L114.695 58.7395C114.788 58.6467 114.955 58.6467 115.067 58.7395L119.25 62.9148C119.362 63.0261 119.362 63.1931 119.25 63.2859Z"
          fill="white"
        />
        <path
          d="M105.919 77.7818C105.51 77.7818 105.12 77.6148 104.822 77.3179L100.639 73.1426C100.026 72.5302 100.026 71.5467 100.639 70.9344L113.784 57.8147C114.397 57.2024 115.383 57.2024 115.996 57.8147L120.179 61.99C120.793 62.6024 120.793 63.5859 120.179 64.1983L107.035 77.3179C106.737 77.6148 106.347 77.7818 105.919 77.7818ZM103.205 72.0478L105.919 74.7571L117.595 63.1034L114.881 60.3941L103.205 72.0478Z"
          fill="#2D2D2D"
        />
        <path
          d="M64.6268 56.1792C64.2922 56.1792 63.9575 56.0493 63.7158 55.8081C63.2139 55.3071 63.2139 54.472 63.7158 53.971L67.899 49.7957C68.4009 49.2947 69.2376 49.2947 69.7395 49.7957C70.2415 50.2967 70.2415 51.1318 69.7395 51.6328L65.5378 55.8081C65.2775 56.0679 64.9429 56.1792 64.6268 56.1792Z"
          fill="#2D2D2D"
        />
        <path
          d="M83.0883 37.7534C82.7536 37.7534 82.419 37.6235 82.1773 37.3823C81.6753 36.8813 81.6753 36.0462 82.1773 35.5452L86.3604 31.3699C86.8624 30.8689 87.699 30.8689 88.201 31.3699C88.703 31.8709 88.703 32.706 88.201 33.207L84.0178 37.3823C83.739 37.6235 83.4043 37.7534 83.0883 37.7534Z"
          fill="#2D2D2D"
        />
        <path
          d="M75.9313 34.8037C75.2062 34.8037 74.6299 34.2284 74.6299 33.5047V27.6037C74.6299 26.8799 75.2062 26.3047 75.9313 26.3047C76.6564 26.3047 77.2327 26.8799 77.2327 27.6037V33.5047C77.2327 34.2284 76.6564 34.8037 75.9313 34.8037Z"
          fill="#2D2D2D"
        />
        <path
          d="M68.7919 37.7534C68.4573 37.7534 68.1226 37.6235 67.8809 37.3823L63.6978 33.207C63.1958 32.706 63.1958 31.8709 63.6978 31.3699C64.1997 30.8689 65.0364 30.8689 65.5384 31.3699L69.7215 35.5452C70.2235 36.0462 70.2235 36.8813 69.7215 37.3823C69.4612 37.6235 69.1266 37.7534 68.7919 37.7534Z"
          fill="#2D2D2D"
        />
        <path
          d="M65.8357 44.8811H59.9235C59.1984 44.8811 58.6221 44.3059 58.6221 43.5822C58.6221 42.8585 59.1984 42.2832 59.9235 42.2832H65.8357C66.5607 42.2832 67.1371 42.8585 67.1371 43.5822C67.1371 44.3059 66.5607 44.8811 65.8357 44.8811Z"
          fill="#2D2D2D"
        />
      </g>
      <defs>
        <filter
          id="filter0_dddd"
          x="15.8066"
          y="0"
          width="147.193"
          height="147.193"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="16" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="24" />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect3_dropShadow" result="effect4_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter1_dddd"
          x="0"
          y="16.6387"
          width="138.042"
          height="100.605"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="16" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="24" />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect3_dropShadow" result="effect4_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter2_dddd"
          x="9.9834"
          y="31.6133"
          width="118.076"
          height="70.6555"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="16" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="24" />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect3_dropShadow" result="effect4_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter3_dddd"
          x="26.6221"
          y="18.3047"
          width="126.017"
          height="115.477"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="16" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="24" />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect3_dropShadow" result="effect4_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow" result="shape" />
        </filter>
        <radialGradient
          id="paint0_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(78.3697 -64.0269) rotate(104.058) scale(137.524 436.513)"
        >
          <stop stopColor="#FFE0BC" />
          <stop offset="1" stopColor="#F2CEA5" />
        </radialGradient>
      </defs>
    </svg>
  )
}
